// Browser floor gate (THEME.md law 10). The v4 surface is built on oklch()
// tokens and :has()-dependent kit selectors — below the floor (Safari/iOS
// 15.4, Chrome/Edge/Android 111, Firefox 121, Samsung 22; package.json
// browserslist) the app renders unstyled/broken, worst inside legacy
// macOS 12 lockdown WKWebViews. Feature detection only — never UA sniffing:
// the two probes encode the floor exactly (oklch → Safari 15.4 / Chrome 111 /
// Firefox 113; :has → Safari 15.4 / Chrome 105 / Firefox 121).
export const isBrowserSupported = (): boolean => {
  try {
    return (
      typeof CSS !== 'undefined' &&
      typeof CSS.supports === 'function' &&
      // PERCENT lightness form on purpose: WebKit 15.4 (the floor) parses
      // `oklch(0% 0 0)` but rejects the number form `oklch(0 0 0)` — and the
      // built CSS ships percent form (lightningcss normalizes). Probing the
      // number form false-gates real 15.4 (proven against Playwright's
      // WebKit 15.4 build).
      CSS.supports('color', 'oklch(0% 0 0)') &&
      CSS.supports('selector(:has(*))')
    );
  } catch {
    return false;
  }
};
